import { render, staticRenderFns } from "./changeEmail.vue?vue&type=template&id=60da5550&scoped=true&"
import script from "./changeEmail.vue?vue&type=script&lang=js&"
export * from "./changeEmail.vue?vue&type=script&lang=js&"
import style0 from "./changeEmail.vue?vue&type=style&index=0&id=60da5550&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60da5550",
  null
  
)

export default component.exports